import { SmartTable } from '../../../../../components/smart-table/smart-table.model';
import { accountFromDto } from '../../../../../states/company/user-directories/account.dto';

export class Controller {

    /** @ngInject */
    constructor($state, $uibModal, Alert, GroupsResource) {
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
        this.GroupsResource = GroupsResource;
    }

    $onInit() {
        this.st = new SmartTable();
        this.isAD = ['AD_DOMAIN', 'AD_GROUP', 'AD_OU'].includes(this.group.type);

        var ctrl = this;
        this.displayed = [];
        this.callServer = function callServer(tableState) {
            ctrl.isLoading = true;
            var pagination = tableState.pagination;
            var page = pagination.start / pagination.number;
            var number = pagination.number;
            var searchText = (tableState.search.predicateObject ? tableState.search.predicateObject.searchText : '');
            var sort = tableState.sort.predicate;
            var sortReverse = tableState.sort.reverse;
            if (ctrl.page != page || ctrl.number != number || ctrl.searchText != searchText || ctrl.sort != sort || ctrl.sortReverse != sortReverse) {
                ctrl.page = page;
                ctrl.number = number;
                ctrl.searchText = searchText;
                ctrl.sort = sort;
                ctrl.sortReverse = sortReverse;
                ctrl.GroupsResource
                    .getAllAccountsForCompanyAndGroupWithPagination(ctrl.companyId, ctrl.group.id, ctrl.page, ctrl.number, ctrl.searchText, ctrl.sort, ctrl.sortReverse)
                    .then(dto => {
                        pagination.totalItemCount = dto.totalElements;
                        pagination.numberOfPages = dto.totalPages;
                        ctrl.st.displayedItems = dto.content.map(accountFromDto);
                })
                .finally(() => ctrl.isLoading = false);
            }
        }

    }

    selectedDeletableItems() {
        return this.st.selectedItems.filter(account => account.isDeletable)
    }

    showRemoveModal() {
        this.$uibModal
            .open({
                component: 'companyUserDirectoriesManageGroupAccountsRemove',
                resolve: {
                    companyId: () => this.companyId,
                    groupId: () => this.group.id,
                    accountIds: () => this.st.selectedIds,
                },
            }).result
            .then(() => {
                const key = 'company.user-directories.manage-group.accounts.remove.removed';
                const variables = {groupName: this.group.groupName};
                this.Alert('success', key, variables);
                this.$state.go(this.$state.current, {} , {reload:true});
            })
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/group-accounts.controller.js